import React from "react";
import { useTranslation } from "react-i18next";
import AppModalShell, { AppModalButton, AppModalContentItem } from "../common/AppModalShell";

export default function CityLaunchModal({ open, city, launched, applied, saving, error, onApply, onClose }) {
  const { t } = useTranslation("events");
  return (
    <AppModalShell
      open={open}
      title={applied ? t("city_launch.success_title") : `🎉 ${t("city_launch.title", { city })} 🎉`}
      titleClassName="!text-[20px] sm:!text-[22px]"
      onClose={onClose}
      closeAriaLabel={t("city_launch.close")}
      closeOnBackdropClick={false}
      maxWidthClassName="max-w-[520px]"
      layout
      footer={(
        <div className={applied ? "" : "grid grid-cols-2 gap-3"}>
          {!applied ? (
            <AppModalButton onClick={onApply} loading={saving}>
              {t(saving ? "city_launch.sending" : "city_launch.apply")}
            </AppModalButton>
          ) : null}
          <AppModalButton onClick={onClose} variant={applied ? "primary" : "secondary"}>
            {t(applied ? "city_launch.browse_events" : "city_launch.skip")}
          </AppModalButton>
        </div>
      )}
    >
      <AppModalContentItem className="space-y-3 text-center text-[15px] font-medium leading-6 text-white/85">
        {applied ? (
          <>
            <div aria-hidden="true" className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-300/10 text-emerald-200">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="m7 16 6 6L25 10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <p role="status">{t("city_launch.success_body")}</p>
          </>
        ) : (
          <>
            <p className="text-white">{t(launched ? "city_launch.intro_launched" : "city_launch.intro_upcoming", { city })}</p>
            <p>{t("city_launch.growing")}</p>
            <p>{t("city_launch.invitation", { city })}</p>
          </>
        )}
        {error ? <p role="alert" className="text-sm text-red-200">{t("city_launch.error")}</p> : null}
      </AppModalContentItem>
    </AppModalShell>
  );
}
